import { useContext, useEffect } from 'react';

import { context as dependencyContext } from '../view/context/dependency';
import { context as stateContext } from '../view/context/state';

export const useNeedSignedIn = () => {
  const { authentication } = useContext(stateContext);
  const { authenticationUsecase } = useContext(dependencyContext);

  useEffect(() => {
    if (!authentication.signedInUser) {
      authenticationUsecase.handleNeedSignedIn();
    }
    // eslint-disable-next-line
  }, [authentication.signedInUser]);
};
